export const QueryKey = {
    OldBelief: "oldBelief"
} as const
